import graphql from 'api/graphql';

const reportError = async (errorData: Record<string, unknown>): Promise<void> => {
  const metricString = JSON.stringify(errorData);
  await graphql.createMetric(metricString);
};

export { reportError };
